import { useOrganizationsFilter } from './hooks/useOrganizationsFilter';

import { MultiSelect } from '@/components/MultiSelect';

export const OrganizationsFilter = () => {
	const [options, organizationFilterValue, onOrganizationFilterChanged] =
		useOrganizationsFilter();
	return (
		<MultiSelect
			options={options}
			value={organizationFilterValue}
			onChange={onOrganizationFilterChanged}
			placeholder="All organizations"
		/>
	);
};
